import ApplicationState from "../../../../Stores/applicationStates"
import axios from "axios"
/**
 * @description Fetches the list of file templates.
 * @param {number} page page number of the file template list
 */
export const getFileListPerPage = async (page) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
      let token
      ApplicationState.subscribe((state) => (token = state.token))
      // Fetching list of document templates
      const { data } = await axios.get(`/api/swagger/v2/templates/files?limit=10&page=${page}&sort=-1&sortBy=date`, {
        headers: {
          "x-access-token": token,
        },
      })

      // Check if the response has an error and is not successful
      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}
/**
 * @description Fetches the list of email templates.
 * @param {number} page page number of the file template list
 */
export const getEmailListPerPage = async (page) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
      let token
      ApplicationState.subscribe((state) => (token = state.token))
      // Fetching list of document templates
      const { data } = await axios.get(`/api/swagger/v2/templates/emails?limit=10&page=${page}&sort=-1&sortBy=date`, {
        headers: {
          "x-access-token": token,
        },
      })

      // Check if the response has an error and is not successful
      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }

      resolve(data)
    } catch (error) {
      reject(error)
    }
  })
}

/**
 * @description Fetches a file template by ID.
 * @returns {Promise<void>}
 */
export const getFileTemplate = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
      let token
      ApplicationState.subscribe((state) => (token = state.token))
      // Fetching document template by ID
      const { data } = await axios.get(`/api/swagger/v2/templates/files/${id}`, {
        headers: {
          "x-access-token": token,
        },
      })

      // Check if the response has an error and is not successful
      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }

      resolve(data.template)
    } catch (error) {
      reject(error)
    }
  })
}
/**
 * @description Fetches a email template by ID.
 * @returns {Promise<void>}
 */
export const getEmailTemplate = (id) => {
  return new Promise(async (resolve, reject) => {
    try {
      if (!window.navigator.onLine) throw "P2BCODE::NETWORK_ERROR"
      let token
      ApplicationState.subscribe((state) => (token = state.token))
      // Fetching document template by ID
      const { data } = await axios.get(`/api/swagger/v2/templates/emails/${id}`, {
        headers: {
          "x-access-token": token,
        },
      })

      // Check if the response has an error and is not successful
      if (data.error && !data.success) {
        throw data.errorCode // Throw the error code
      }

      resolve(data.template)
    } catch (error) {
      reject(error)
    }
  })
}
